import { render, staticRenderFns } from "./MatchHistory.vue?vue&type=template&id=93804190&scoped=true"
import script from "./MatchHistory.vue?vue&type=script&lang=ts"
export * from "./MatchHistory.vue?vue&type=script&lang=ts"
import style0 from "./MatchHistory.vue?vue&type=style&index=0&id=93804190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93804190",
  null
  
)

export default component.exports